import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListHeader from '@/common/components/ListHeader'
import Table from '@/common/components/Table'
import TextField from '@/common/components/TextField'
import { useEquipmentCategories } from '@/common/hooks/queries/useEquipmentCategories'
import useDebounce from '@/common/hooks/useDebounce'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { EquipmentCategoriesTransformer } from '@/features/equipmentCategories/services/equipmentCategoriesTransformer'
import { EquipmentCategoryData, EquipmentCategoryTableItem } from '@/features/equipmentModels/types/equipmentCategories'
import { CarFront, Search } from 'lucide-react'
import { defaultColumns } from '../../constants/columns.constant'

const EquipmentCategoriesList = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const [search, setSearch] = useDebounce(filterParams.search || '')

  const {
    data: equipmentCategories,
    meta,
    isLoading: equipmentCategoriesIsLoading,
    error: equipmentCategoriesError = {} as any,
    refetch: refetchEquipmentCategories,
  } = useEquipmentCategories({
    filters: {
      search: search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<EquipmentCategoryData[], EquipmentCategoryTableItem[]>({
      transformer: EquipmentCategoriesTransformer.tableTransformer('Admin::EquipmentCategories::Show'),
    }),
  })

  return (
    <div>
      <div className="flex flex-col gap-6">
        <ListHeader Icon={<CarFront className="w-10 h-10" strokeWidth={1.5} />} title="Categorias de equipamento" />

        <ErrorMessageWrapper
          className="h-[calc(100vh-128px)] flex flex-col gap-6"
          statusCode={equipmentCategoriesError?.status}
          refetchFunction={refetchEquipmentCategories}
        >
          <TextField
            LeftIcon={<Search />}
            placeholder="Pesquisar"
            className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
            onChange={(e) => {
              setSearch((e.target as HTMLInputElement).value)
              setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }))
            }}
            value={filterParams.search}
          />

          <Table
            className="max-h-[calc(100vh-204px)]"
            columns={defaultColumns}
            isLoadingData={equipmentCategoriesIsLoading}
            page={filterParams.page || 1}
            rows={equipmentCategories}
            rowEmptyValue="--"
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </ErrorMessageWrapper>
      </div>
    </div>
  )
}

export default EquipmentCategoriesList
